<template>
  <div
    ref="heroImage"
    class="home-hero"
    :class="[
      { 'home-hero-between': isBetweenCampaign },
      { 'home-hero-after': isSwrClosedInAfterCampaign }
    ]"
  >
    <v-container class="fill-height">
      <v-row justify="end" align="end" class="fill-height">
        <v-col cols="12" class="fill-height d-flex align-center">
          <v-row align="start" justify="start" no-gutters>
            <v-col cols="3" sm="2">
              <LogoComponent />
            </v-col>
            <v-col cols="9" sm="10" class="px-3 d-flex align-self-center">
              <h1
                v-orphans
                class="mb-0 sz-white--text font-weight-medium"
                :class="[isSelectVisible ? 'text-h2' : 'text-h3']"
                v-html="heroTitle"
              />
            </v-col>
            <v-col cols="12" sm="10" class="offset-sm-2 px-3">
              <v-col cols="12" md="10" lg="9" xl="8" class="mt-0 pl-0">
                <h4
                  v-if="stateSubtitle"
                  v-orphans
                  class="mb-0 sz-white--text font-weight-medium text-wrap-balance"
                  :class="[
                    { 'f-20': !isSelectVisible },
                    { 'text-h4': isSelectVisible },
                    { 'bg-text-dark-shadow': isSwrClosedInAfterCampaign }
                  ]"
                  v-html="stateSubtitle"
                />
                <h4
                  v-if="isSwrClosedInBeforeCampaign"
                  v-orphans
                  class="mb-0 sz-white--text font-weight-medium text-wrap-balance"
                  :class="[isSelectVisible ? 'text-h4' : 'f-20']"
                  v-html="$t('home.beforeSubtitle2')"
                />
              </v-col>
              <v-col
                v-if="isSelectVisible"
                cols="12"
                sm="9"
                md="6"
                class="mt-0 sz-white pa-6 rounded-block"
              >
                <v-row align="center" justify="start" no-gutters>
                  <v-col cols="12">
                    <p class="f-18 font-weight-regular sz-primary-grey--text mb-0">
                      {{ $t('home.choose_province') }}
                    </p>
                  </v-col>
                  <v-col cols="12">
                    <v-autocomplete
                      ref="autocomplete"
                      v-model="selectedProvinceId"
                      autocomplete="off"
                      :label="$t('label.choose_province')"
                      :items="provincesList"
                      item-value="province_id"
                      item-title="province_name"
                      class="home-hero__autocomplete sz-primary-grey--text mt-0"
                      color="szGrey"
                      :menu-props="{
                        closeOnContentClick: true,
                        maxHeight: maxHeightMenu
                      }"
                      single-line
                      hide-details
                      :loading="bubblesLoader || provincesLoader"
                      auto-select-first
                      menu-icon="$expand"
                    >
                      <template #item="{ item, props }">
                        <template v-if="item.raw.active">
                          <v-list-item v-bind="props">
                            <template #title>
                              <v-list-item-title class="f-16">
                                {{ item.raw.province_name }}
                              </v-list-item-title>
                            </template>
                          </v-list-item>
                        </template>
                        <template v-else>
                          <!-- DESKTOP TEMPLATE -->
                          <v-list-item
                            v-bind="props"
                            class="text-disabled d-none d-sm-flex"
                            @click.stop="showInactiveProvinceModal(item.raw)"
                          >
                            <template #title>
                              <v-list-item-title class="f-16">
                                {{ props.title }}
                                <span class="px-2">|</span>
                                <span class="font-italic">{{ $t('home.noFamilies') }}</span>
                              </v-list-item-title>
                            </template>
                          </v-list-item>

                          <!-- MOBILE TEMPLATE -->
                          <v-list-item
                            v-bind="props"
                            class="text-disabled d-block d-sm-none"
                            @click.stop="showInactiveProvinceModal(item.raw)"
                          >
                            <template #title>
                              <v-list-item-title class="f-16">
                                {{ item.raw.province_name }}
                              </v-list-item-title>
                              <v-list-item-subtitle class="f-12 font-italic">
                                {{ $t('home.noFamilies') }}
                              </v-list-item-subtitle>
                            </template>
                          </v-list-item>
                        </template>
                      </template>
                    </v-autocomplete>
                  </v-col>
                  <v-col cols="12" class="mt-3">
                    <v-row no-gutters justify="center">
                      <v-col cols="12" class="px-0">
                        <p v-orphans class="f-16 font-weight-medium sz-primary-red--text mb-0">
                          <strong v-if="isMobilizationPhase">
                            {{ missingDonorsUrgent }}
                          </strong>
                          <template v-else>{{ waitingFamilies }}</template>
                        </p>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
              <v-col v-else-if="isBetweenCampaign" class="pl-0" cols="auto">
                <v-row wrap no-gutters jusify="center" align="center">
                  <v-col cols="12" md="auto" :class="{ 'pr-5': mdAndUp }">
                    <BaseButton
                      v-if="showDonateButton"
                      :id="donateButtonId"
                      block-mobile
                      arrow
                      :href="szpPaymentLink"
                    >
                      <span class="d-none d-md-inline">{{ $t('label.donateForSzp') }}</span>
                      <span class="d-inline d-md-none">{{ $t('label.donateToHelp') }}</span>
                    </BaseButton>
                  </v-col>
                </v-row>
              </v-col>
              <v-col v-else class="pl-0" cols="auto" align-self="center">
                <BaseButton
                  v-if="showDonateButton"
                  :id="donateButtonId"
                  block-mobile
                  arrow
                  :href="szpPaymentLink"
                >
                  <span class="d-none d-md-inline">{{ $t('label.donateForSzp') }}</span>
                  <span class="d-inline d-md-none">{{ $t('label.donateToHelp') }}</span>
                </BaseButton>
              </v-col>
            </v-col>
          </v-row>
        </v-col>
        <v-col
          v-if="showScrollDown"
          cols="12"
          class="home-hero__scroll-down mb-0 pb-0 text-center font-weight-regular"
        >
          <a class="sz-white--text f-14 mb-0 disable-text-decoration" @click="scrollToInfo">
            <v-btn
              height="36"
              width="36"
              class="text-szLightGrey f-14"
              color="white"
              icon="$arrowDown"
              variant="flat"
            />
            <span class="ml-2">{{ $t('home.scrollDown') }}</span>
          </a>
        </v-col>
      </v-row>
    </v-container>
    <InactiveProvinceModal ref="inactiveProvinceModal" :province="selectedInactiveProvince" />
  </div>
</template>

<script setup lang="ts">
import InactiveProvinceModal from '@/components/Home/InactiveProvinceModal.vue'
import BaseButton from '@/components/widgets/BaseButton.vue'
import LogoComponent from '@/components/widgets/LogoComponent.vue'
import { LINKS } from '@/constants/externalLinks'
import { useFeatureFlags } from '@/composables/useFeatureFlags'
import { FEATURE_FLAG } from '@/constants/featureFlags'
import { useTidio } from '@/stores/Tidio'
import getLangsVariable from '@/utils/getLangsVariable'
import { storeToRefs } from 'pinia'
import { computed, onMounted, ref, watch, useTemplateRef } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRoute, useRouter } from 'vue-router'
import { useDisplay, useGoTo } from 'vuetify'
// @ts-expect-error: Importing Vuex store
import { useStore } from 'vuex'
import useEditionStageStore from '@/stores/EditionStage'
import type { TODO, Maybe } from '@/types'

type Props = {
  showScrollDown?: boolean
}

defineProps<Props>()

const { t } = useI18n()
const goTo = useGoTo()
const store = useStore()
const router = useRouter()
const route = useRoute()

const { mdAndUp, smAndUp } = useDisplay()
const { isFeatureEnabled } = useFeatureFlags()

const isMobilizationPhase = isFeatureEnabled(FEATURE_FLAG.IS_MOBILIZATION_PHASE)

type ProvinceId = number
type Province = {
  province_id: ProvinceId
  province_name: string
  active: boolean
}
const selectedProvinceId = ref<Maybe<ProvinceId>>(null)
const szpPaymentLink = ref(LINKS.szpPaymentFormMain)
const selectedInactiveProvince = ref(null)

const autocomplete = useTemplateRef('autocomplete')
const heroImage = useTemplateRef('heroImage')
const inactiveProvinceModal = useTemplateRef('inactiveProvinceModal')

const editionStageStore = useEditionStageStore()
const {
  isBeforeCampaign,
  isAfterCampaign,
  isBetweenCampaign,
  isSwrOpen,
  isSwrClosedInBeforeCampaign,
  isSwrClosedInAfterCampaign
} = storeToRefs(editionStageStore)

const provincesList = computed<Province[]>(() => store.getters['provinces/getProvinces'])
const bubblesLoader = computed(() => store.getters['bubbles/getLoader'])
const provincesLoader = computed(() => store.getters['provinces/getLoader'])
const currentProvinceName = computed(() => {
  const province = provincesList.value.find(
    (el: TODO) => el.province_id === selectedProvinceId.value
  )
  return province ? province.province_name : ''
})
const isSelectVisible = computed(() => isSwrOpen.value)

const gtmTitle = computed(() => getLangsVariable(['HOME_PAGE', 'title']))

const donateButtonId = computed(() => {
  if (isBeforeCampaign.value) {
    return 'swr-step0-payment-before-start-button'
  } else if (isAfterCampaign.value) {
    return 'swr-step0-payment-after-final-button'
  } else if (isBetweenCampaign.value) {
    return 'swr-step0-payment-between-campaign-button'
  }

  return ''
})

const showDonateButton = computed(() => donateButtonId.value !== '')

const stateTitle = computed(() => {
  if (isSwrClosedInBeforeCampaign.value) {
    return t('home.beforeTitle')
  } else if (isSwrClosedInAfterCampaign.value) {
    return t('home.afterTitle')
  } else if (isBetweenCampaign.value) {
    return t('home.betweenTitle')
  }

  return t('home.title')
})
const stateSubtitle = computed(() => {
  if (isSwrClosedInBeforeCampaign.value) {
    return t('home.beforeSubtitle')
  } else if (isSwrClosedInAfterCampaign.value) {
    return t('home.afterSubtitle')
  } else if (isBetweenCampaign.value) {
    return t('home.betweenSubtitle')
  }

  return t('home.subtitle')
})

const heroTitle = computed(() => gtmTitle.value || stateTitle.value)

const waitingFamilies = computed(() => {
  if (Number.isNaN(familiesAmount.value)) return ''
  let value = familiesAmount.value
  if (getLangsVariable(['HOME_PAGE', 'familiesAmount'])) {
    value = parseInt(getLangsVariable(['HOME_PAGE', 'familiesAmount'])) - helpedFamiliesAmount.value
  }
  if (getLangsVariable(['HOME_PAGE', 'waitingFamilies'])) {
    return getLangsVariable(['HOME_PAGE', 'waitingFamilies']).replace('{counter}', value)
  }
  return t('home.waiting_families', value)
})
const missingDonorsUrgent = computed(
  () => getLangsVariable(['HOME_PAGE', 'missingDonorsUrgent']) || t('home.missing_donors_urgent')
)
const familiesAmount = computed(() => store.getters['provinces/getFamiliesAmount'])
const helpedFamiliesAmount = computed(() => store.getters['provinces/getFamiliesHelpedAmount'])
const maxHeightMenu = computed(() => (smAndUp.value ? 300 : 150))

watch(selectedProvinceId, (value) => {
  store.commit('bubbles/setBubbles', null)
  if (value) {
    store.commit('provinces/setCurrentProvinceId', value)
    store.dispatch('bubbles/getBubbles', value)
    if (autocomplete.value) {
      autocomplete.value.blur()
    }
  }
})

watch(currentProvinceName, (val) => {
  const newProvince = val || undefined
  store.commit('provinces/setCurrentProvinceName', newProvince)
  const currentRouteName = router.currentRoute.value.name
  if (router.currentRoute.value.query?.province === val) return
  router.replace({ name: currentRouteName, query: { province: newProvince } })
})

watch(route, () => {
  setFilterFromQuery()
})

const tidioStore = useTidio()
const { isDisplayChat, isHideChatOnClose, isTidioChatEnabledBasedOnEditionStage } =
  storeToRefs(tidioStore)

const changeTidioVisibilitySettingsOnProvinceChoose = (): void => {
  if (!isTidioChatEnabledBasedOnEditionStage.value) return
  if (route.query?.province) {
    isDisplayChat.value = true
    isHideChatOnClose.value = false
  } else {
    isDisplayChat.value = false
    isHideChatOnClose.value = false
  }
  tidioStore.setChatVisibilityBasedOnRefs()
}

watch(
  route,
  () => {
    changeTidioVisibilitySettingsOnProvinceChoose()
  },
  { immediate: true }
)

onMounted(() => {
  if (getLangsVariable(['HOME_PAGE', 'heroImageUrl']) && heroImage.value) {
    heroImage.value.style.background = `url('${getLangsVariable(['HOME_PAGE', 'heroImageUrl'])}')`
  }
  if (!selectedProvinceId.value)
    selectedProvinceId.value = store.getters['provinces/getCurrentProvinceId']

  setFilterFromQuery()
})

function scrollToInfo() {
  goTo('#firstInfoContainer', {
    offset: 48,
    easing: 'easeInQuad'
  })
}

function showInactiveProvinceModal(provinceItem: TODO) {
  selectedInactiveProvince.value = provinceItem
  selectedProvinceId.value = null
  if (autocomplete.value) autocomplete.value.blur()
  if (inactiveProvinceModal.value) inactiveProvinceModal.value.open()
}

function setFilterFromQuery() {
  const { query } = route
  const selectedProvince = provincesList.value?.find(
    (province: TODO) => province?.province_name === query?.province
  )
  if (selectedProvince?.active === false) showInactiveProvinceModal(selectedProvince)
  else selectedProvinceId.value = selectedProvince?.province_id ?? null
}
</script>
<style lang="scss">
.home-hero {
  &__autocomplete {
    .v-field-label {
      color: #414345;
      opacity: 1;
    }
  }

  &__scroll-down {
    transform: translateY(-50px);
  }
}
</style>
